import { render, staticRenderFns } from "./expression.vue?vue&type=template&id=5512891d&scoped=true&"
import script from "./expression.vue?vue&type=script&lang=js&"
export * from "./expression.vue?vue&type=script&lang=js&"
import style0 from "./expression.vue?vue&type=style&index=0&id=5512891d&prod&lang=scss&scoped=true&"
import style1 from "./expression.vue?vue&type=style&index=1&id=5512891d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5512891d",
  null
  
)

export default component.exports